import { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { officerNav } from '../components/officerNav';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

function Widget({ label, value, onClick }) {
  return (
    <Card sx={{ cursor: onClick ? 'pointer' : 'default', height: '100%' }} onClick={onClick}>
      <CardContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>{label}</Typography>
        <Typography variant="h4" color="primary">{value}</Typography>
      </CardContent>
    </Card>
  );
}

export default function OfficerDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [counts, setCounts] = useState({ active: 0, awaitingOpening: 0, evaluating: 0, awardedQuarter: 0 });

  useEffect(() => {
    (async () => {
      // Active tenders = published. The other three are Phase 2+ metrics (shown as 0 for now).
      const { data } = await api.get('/tenders', { params: { status: 'PUBLISHED', pageSize: 1 } });
      setCounts((c) => ({ ...c, active: data.meta?.total || 0 }));
    })();
  }, []);

  return (
    <DashboardLayout nav={officerNav} welcomeName={user?.fullName} title="Dashboard">
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button variant="contained" onClick={() => navigate('/officer/tenders/new')}>Create Tender</Button>
      </Stack>

      {/* Four widgets exactly per wireframe */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Widget label="Active Tenders" value={counts.active} onClick={() => navigate('/officer/tenders')} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Widget label="Bids Awaiting Opening" value={counts.awaitingOpening} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Widget label="Evaluations in Progress" value={counts.evaluating} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Widget label="Contracts Awarded This Quarter" value={counts.awardedQuarter} />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}
